import React, { useEffect, useState } from 'react';

import { CrewMember, Registration } from '../../../hooks/api/utils/types';
import { getCrewMembers } from '../../../services/api/crewMembers';
import { getRegistrationCrewMembers } from '../../../services/api/registrationCrewMembers';
import registrationsForm from '../RegistrationsForm';
import CustomTypeahead from '../fields/CustomTypeahead';

interface Props {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  name: string;
  filters?: Record<string, any>;
  defaultCrewMember?: CrewMember;
  registration: Registration;
  values: any;
  onChange: (values: CrewMember | null) => void;
  labelFn?: (option: CrewMember) => string;
}

const CrewMemberSelect: React.FC<Props> = (props) => {
  const [crewMembers, setCrewMembers] = useState<CrewMember[]>([]);

  useEffect(() => {
    props.setFieldValue(props.name, null);
    setCrewMembers([]);
  }, [props.registration]);

  const handleCrewMemberSearch = (value: string) => {
    getRegistrationCrewMembers(props.registration.id, {
      ...(props.filters || []),
      'include': 'user',
      'filter[name_like]': value,
    }).then((response) => {
      setCrewMembers(response.data);
    });
  };

  const handleOnChange = (values: CrewMember[]) => {
    props.onChange(values[0] || null);
    props.setFieldValue(props.name, values[0]?.id);
  };

  function getLabelKey(crewMember: CrewMember): string {
    if (props.labelFn) {
      return props.labelFn(crewMember);
    }

    return crewMember.user!.fullName;
  }

  return (
    <CustomTypeahead
      id="crewMemberSelect"
      label="Crew Member"
      multiple={false}
      options={crewMembers}
      selected={crewMembers.filter((cm) => cm.id === props.values.crewMemberId || props.defaultCrewMember?.id)}
      placeholder="Choose a crew member"
      labelKey={getLabelKey}
      onSearch={handleCrewMemberSearch}
      errors={[]}
      {...props}
      onChange={handleOnChange}
    />
  );
};

export default CrewMemberSelect;
